import React, { useContext } from 'react';
import { Badge, Tabs } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageScaffold from '../../components/PageScaffold';
import CompanyContext from '../../contexts/company/CompanyContext';
import { useMySubscriptionId } from '../../hooks/subscription/useMySubscriptionId';
import useReceptionistCallsTabController from './controllers/useReceptionistCallsTabController';
import ReceptionistCallsTab from './tabs/ReceptionistCallsTab';
import ReceptionistSettingsTab from './tabs/ReceptionistSettingsTab';
import CompanyPageHeader from '../company/CompanyPageHeader';
import { getCompanyTabPath } from '../company/useCompanyTabs';
import './ReceptionistAiListPage.css';

export const RECEPTIONIST_AI_PAGE_PATH = getCompanyTabPath('ai-receptionist');
export const RECEPTIONIST_AI_PAGE_TITLE = 'Réceptionniste IA';

type ReceptionistAiTab = 'appels' | 'parametres';

interface ReceptionistAiListPageProps { }

const ReceptionistAiListPage: React.FC<ReceptionistAiListPageProps> = () => {
  const { activeCompany } = useContext(CompanyContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const mySubscriptionId = useMySubscriptionId();
  const isSupervisor = !!activeCompany?.isSupervisor;
  const callsController = useReceptionistCallsTabController();

  // Derive active tab from the "tab" query param, default to 'appels'
  const activeTab: ReceptionistAiTab = isSupervisor && searchParams.get('tab') === 'parametres' ? 'parametres' : 'appels';

  const setActiveTab = (tab: string) => {
    // A member has no settings table: the tab opens their own receptionist
    if (tab === 'parametres' && !isSupervisor) {
      navigate(`${RECEPTIONIST_AI_PAGE_PATH}/${mySubscriptionId}`);
      return;
    }
    if (tab === 'appels') {
      searchParams.delete('tab');
    } else {
      searchParams.set('tab', tab);
    }
    setSearchParams(searchParams, { replace: true });
  };

  const items = [
    {
      key: 'appels',
      label: (
        <span className="receptionist-ai-page__tab-label">
          Appels
          <Badge count={callsController.state.unreadCount} size="small" />
        </span>
      ),
      children: <ReceptionistCallsTab controller={callsController} />,
    },
    ...(isSupervisor ? [{ key: 'parametres', label: 'Paramètres des réceptionnistes', children: <ReceptionistSettingsTab /> }] : []),
    ...(!isSupervisor && mySubscriptionId ? [{ key: 'parametres', label: 'Ma réceptionniste' }] : []),
  ];

  return (
    <PageScaffold
      header={<CompanyPageHeader />}
      title={activeTab === 'parametres' ? 'Paramètres des réceptionnistes' : RECEPTIONIST_AI_PAGE_TITLE}
      subtitle={activeTab === 'parametres' ? 'Personnalisez Donna pour chaque utilisateur de votre équipe.' : ' '}
      breadcrumbItems={[{ title: ' ' }]}
    >
      <Tabs
        className="receptionist-ai-page__tabs"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
      />
    </PageScaffold>
  );
};

export default ReceptionistAiListPage;
